<template>
    <b-container id="about" class="d-flex flex-column justify-content-start align-items-center" style="min-height: 100vh; padding-left: 25px; padding-right: 25px">

        <h2>Quem Somos</h2>
        
        <div class="w-100 d-flex justify-content-between align-items-center box">
            <span 
                v-for="(title, index) in titles" :key="index"
                @click="selectedSection = title" 
                :class="{ active: selectedSection === title }"
            >
                {{ title }}
            </span>
        </div>

        <transition name="slide-fade" mode="out-in">
            <section
                v-for="section in sections"
                v-if="section.title === selectedSection"
                :key="section.title"
                class="d-flex align-items-center justify-content-between content"
            >
                <div class="d-flex flex-column justify-content-start h-100 pt-5">
                    <p>{{ section.paragraph }}</p>
                    <ul v-for="(item, index) in section.list" :key="index">
                        <li>
                            <span v-if="item.key" style="color: var(--primary); text-transform: capitalize;">{{ item.key }}</span>
                            {{ item.value }}
                        </li>
                    </ul>
                </div>
                <img :src="section.image" />
            </section>
        </transition>

    </b-container>
</template>


<script>
import dataSections from '@/data/sections.js';

    export default {

        data() {
            return {
                selectedSection: '',
                titles: [],
                sections: dataSections,
            }
        },

        mounted(){
            const dataTitles = this.sections.map((item) => item.title);
            this.titles = dataTitles
            this.selectedSection = this.titles[0]
        }

    }

</script>

<style scoped lang="scss">
    #about {
        padding-top: 10rem;
    }

    h2 {
        width: 100%;
        height: 15%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-align: left;
        font-weight: bold;
        margin-bottom: 1rem;
    }

    .content {
        gap: 2rem;
        padding-top: 1.5rem;
        flex-wrap: wrap;

        div {
            width: 30%;
            p {
                font-weight: 300;
            }
            ul {
                padding-left: 1rem;
                
                li {
                font-weight: bold;
                list-style-image: url('../../assets/page/about/squareList.png');
            }
            }
        }

        img {
            width: 600px;
            height: 420px;
            border-radius: .51rem;
        }
    }

    .box {
        
        span {
            cursor: pointer;
            text-align: center;
            border-bottom: 0.5px solid var(--gray);
            font-weight: 400;
            width: 100%;
            transition: all 0.3s ease;
            
            &:first-child{
                text-align: left !important;
            }

            &:hover {
                border-bottom: 2px solid var(--primary);
                font-weight: 600;
            }

            &.active {
                border-bottom: 2.5px solid var(--primary);
                font-weight: 700;
            }
        }
    }

    .slide-fade-enter-active, .slide-fade-leave-active {
        transition: all 0.4s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }

    @media screen and (max-width: 992px){
        .content {
            justify-content: center !important;
            align-items: center;

            div {
                padding: 0 !important;
                width: 100%;
            }

            img{
                width: 100%;
                margin: 0 1rem
            }
        }
    }

    @media screen and (max-width: 500px) {
        #about {
            padding-top: 5rem;
        }
        .content {
            flex-direction: column-reverse;
            justify-content: center !important;
        }
        img {
            object-fit: cover;
            margin: 0 !important
        }
    }


</style>